import { ROUTES } from './routes';
import type { NavIconName } from '@/components/icons/NavIcons';

export interface NavItem {
  to: string;
  label: string;
  end?: boolean;
  icon?: NavIconName;
  matchPaths?: string[];
}

export const userMainNav: NavItem[] = [
  { to: ROUTES.dashboard, label: 'Overview', end: true, icon: 'overview' },
  { to: ROUTES.dashboardAirtime, label: 'Buy Airtime', icon: 'airtime' },
  { to: ROUTES.dashboardData, label: 'Buy Data', icon: 'data' },
];

export const userBillsNav: NavItem[] = [
  { to: ROUTES.dashboardElectricity, label: 'Electricity', icon: 'electricity' },
  { to: ROUTES.dashboardCableTv, label: 'Cable TV', icon: 'cable' },
  { to: ROUTES.dashboardExams, label: 'Exams', icon: 'exams' },
];

export const userServicesNav: NavItem = {
  to: ROUTES.dashboardServices,
  label: 'Verification',
  icon: 'services',
};

export const userBottomNav: NavItem[] = [
  { to: ROUTES.dashboardTransactions, label: 'Transactions', icon: 'transactions' },
  { to: ROUTES.dashboardProfile, label: 'Profile', icon: 'profile' },
  { to: ROUTES.dashboardSecurity, label: 'Security', icon: 'security' },
  { to: ROUTES.dashboardContactSupport, label: 'Contact Support', icon: 'support' },
];

export const mobileNav: NavItem[] = [
  { to: ROUTES.dashboard, label: 'Home', end: true, icon: 'overview' },
  { to: ROUTES.dashboardAirtime, label: 'Airtime', icon: 'airtime' },
  { to: ROUTES.dashboardData, label: 'Data', icon: 'data' },
  {
    to: ROUTES.dashboardServices,
    label: 'Verify',
    icon: 'services',
    matchPaths: ['/dashboard/services', '/dashboard/verify'],
  },
  { to: ROUTES.dashboardProfile, label: 'Profile', icon: 'profile' },
];
